import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

import { makeStyles } from "@material-ui/core/styles";
import { Toolbar, Typography, Menu, MenuItem, Button } from "@material-ui/core";
import { ArrowDropDown as ArrowDropDownIcon } from "@material-ui/icons";

import {
  setAssignedPlacements,
  setStartDate
} from "../../actions/app/creatives";
import { clearAssignedCreatives } from "../../actions/dcm/assignedCreatives";
import HelperTooltip from "../Shared/HelperTooltip/HelperTooltip";
import { MultiTraffickButton } from "./MultiTraffickButton";

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    marginBottom: ".3vw"
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main
          // backgroundColor: lighten(theme.palette.secondary.light, 0.85)
        }
      : {
          color: theme.palette.text.primary
          // backgroundColor: theme.palette.secondary.dark
        },
  title: {
    flex: "1",
    marginRight: theme.spacing(2)
  },
  tablePagination: {
    marginTop: 0
  }
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { isAddingCreativeAllowed, numSelected, selected } = props;

  const dispatch = useDispatch();

  const onUploadOptionSelected = () => {
    //set start date to 2 minutes in the future
    //when the user begins to traffic placements
    let startDate = dayjs().add(2, "minutes").format("YYYY-MM-DDTHH:mm");
    // we must clear assigned creatives before moving to the
    // upload process, so creatives can be properly reloaded there
    dispatch(setStartDate(startDate));
    dispatch(clearAssignedCreatives(selected));
    dispatch(setAssignedPlacements(selected));
  };

  return (
    <Toolbar
      color="secondary"
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0
      })}
    >
      {numSelected > 0 && (
        <>
          <Typography
            className={classes.title}
            color="secondary"
            variant="subtitle1"
          >
            {numSelected} selected
          </Typography>

          <MultiTraffickButton
            selectedPlacements={selected}
            isAddingCreativeAllowed={isAddingCreativeAllowed}
            onSubmit={onUploadOptionSelected}
          />

          <HelperTooltip tooltipText="Prior to associating creative, please associate default creatives for all sizes excluding 1x1. Default creative requires generic messaging and must be static for display (non-video placements). I.e. select all 300x250 placements, associate a static and submit. Now the 300x250 placements can be associated to their respective creative rotation. For more information, please visit the Help page." />
        </>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired
};

export default EnhancedTableToolbar;
